export const ECREDITS_GUIDE_LINK = 'https://support.ecredits.com/support/solutions/categories/66000063014';

export const GA_ENDPOINT = 'https://www.googletagmanager.com/gtag/js?id=';

export const SUBSCRIPTION_TERMS = 'https://dl.ecredits.com/legal/Subscription_terms.pdf';

export const BUY_ECS_TERMS_AND_CONDITIONS = 'https://dl.ecredits.com/legal/exchange-gtc.pdf';

export const DEALS_TERMS_AND_CONDITIONS = 'https://dl.ecredits.com/legal/deals_terms.pdf';

export const EWALLET_TERMS_OF_SERVICE = 'https://ecredits.com/en/ewallet-app-general-terms-of-service/';
